import { createNoise2D } from "simplex-noise";
import styled, { keyframes } from "styled-components";


const noise2D = createNoise2D()
const noiseIteration = 400
const noiseFactor = 2
const noiseLimits = [ 0.75, 0.9 ]

const flicker = keyframes`
  ${[...Array(noiseIteration + 1)].map(
    (item, index) => 
      `${index * (100 / noiseIteration)}% { opacity: ${
        Math.min(noiseLimits[1], Math.max(noiseLimits[0], noiseFactor * Math.abs(noise2D(index * noiseFactor, 0))))
      }; }`
  )}
`;

export default styled.div`
    padding: 43px 46px;
    width: 100%;
    background: linear-gradient(
        to bottom,
        #8f941150 50%,
        #00000020 50%
    );
    background-size: 100% 4px;
    animation: ${flicker} ${Math.ceil(1 / 60 * noiseIteration)}s infinite;
    display: block;
    box-sizing: border-box;
    font-size: 1.2rem;
    color: #ffcf09;
    font-family: 'Cascadia Mono', monospace;
    width: 100%;
    text-shadow:
        1px 2px 4px #ffcf0992,
        0px 0px 25px #ffcf0992,
        0px 0px 30px #ffcf0992;
    text-align: left;
    letter-spacing: 1px;
    white-space: pre-wrap;
    overflow: hidden;
    
  pointer-events: auto;
`
